import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionZonaSalarialComponent {
  editando

  constructor() {
    this.proyectoId = undefined
    this.data = undefined
    this.editando = false
  }
}

module.component('fanProyectoConfigZonaSalarial', {
  controller: FanProyectoConfiguracionZonaSalarialComponent,
  template: template,
  bindings: {
    proyectoId: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/zonaSalarial/component.js